import { parse } from 'date-fns';

export const parseActorDate = (actorDate?: string) => {
  // If the Actor date is midnight, set it to 12h to avoid changing date in different time zones
  const date = actorDate && actorDate.endsWith('000000') ? actorDate.replace('000000', '120000') : actorDate;
  const dateWithTimeZone = `${date}+00:00`;
  return parse(dateWithTimeZone, 'yyyyMMdd HHmmSSXXX', new Date());
};
